import clsx from 'clsx'

import { FvNavLink, Icon } from '@fv/client-components'

import { ShipperTooltip } from '@/components/ShipperTooltip'

import { useRole } from '../auth/hooks'
import { useNotificationCount } from './queries'

export const NotificationsLink = () => {
  const unreadQuery = useNotificationCount({
    onlyUnread: true,
  })
  const role = useRole()
  const unreadCount = unreadQuery.data ?? 0
  if (role === 'vendor') return null
  if (unreadQuery.isLoading) {
    return <Icon icon="spinner" />
  }
  return (
    <ShipperTooltip label={`${unreadCount} unread notifications`}>
      <FvNavLink
        to="/notifications"
        rel="noreferrer"
        className={clsx('flex items-center group overflow-hidden', {
          ' bg-fv-orange-50 shrink-0 border-2 border-fv-orange-bright rounded-md hover:bg-fv-blue-50 hover:border-fv-blue':
            unreadCount > 0,
        })}
      >
        <Icon
          icon="bell-on"
          transform="up-.5"
          className={clsx('block', {
            'bellshake-animation text-fv-orange-bright group-hover:text-fv-gray-dark group-hover:animate-none group px-2':
              unreadCount > 0,
          })}
        />
        {unreadCount > 0 && (
          <div className="text-xs font-semibold group-hover:bg-fv-blue-200 bg-fv-green-100 p-2 border-l border-fv-green-300 group-hover:border-fv-blue ">
            {unreadCount}
          </div>
        )}
      </FvNavLink>
    </ShipperTooltip>
  )
}
